<template>
  <div class="lego-tab__content" :class="contentClass">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'legoTabContent',
  inject: ['tabBox'],
  props: {
    idx: [String, Number],
    label: String,
  },
  computed: {
    currIdx() {
      return this.tabBox.currIdx.value;
    },
    isActive() {
      return this.idx === this.currIdx;
    },
    contentClass() {
      let clazz = [];
      if (this.isActive) {
        clazz.push('lego-tab__content--active');
      }

      return clazz;
    },
  },
};
</script>
